import React from 'react';

import { FormattedDate } from 'react-intl-next';

type EventDateProps = {
	date: string | undefined;
};

export const EventDate = ({ date }: EventDateProps): React.JSX.Element | null => {
	if (!date) {
		return null;
	}
	const event = new Date(date);

	return <FormattedDate value={event} month="short" day="numeric" year="numeric" />;
};
